import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaterialsModule } from '@library/common/materials';

import { StatusLegendComponent } from './status-legend.component';

@NgModule({
  imports: [ CommonModule, MaterialsModule ],
  declarations: [ StatusLegendComponent ],
  exports: [ StatusLegendComponent ],
})
export class StatusLegendModule { }
